const { ROOT_URL } = require("config");

const refreshToken = async () => {
  try {
    // Logic to refresh the token
    // For example, using a refreshToken to get a new accessToken
    let formData = new FormData();
    formData.append("refresh", localStorage.getItem("refresh"));
    const refreshResponse = await fetch(ROOT_URL + "/auth/refresh/", {
      method: "POST",
      body: formData,
    });

    if (!refreshResponse.ok) {
      throw new Error("Could not refresh the token.");
    }

    const data = await refreshResponse.json();
    localStorage.setItem("access", data.access);
    return true;
  } catch (error) {
    console.error("Error refreshing token:", error);
    return false;
  }
};

export async function fetchWithTokenRefresh(url, options = {}) {
  // Inject the Authorization header into all requests
  const accessToken = localStorage.getItem("access");
  if (accessToken) {
    options.headers = {
      ...options.headers,
      Authorization: `Bearer ${accessToken}`,
    };
  }

  // Perform the fetch call
  let response = await fetch(url, options);

  // If the response is unauthorized, try to refresh the token
  if (response.status === 401) {
    const didRefresh = await refreshToken();
    if (didRefresh) {
      // Update accessToken after refresh
      const newAccessToken = localStorage.getItem("access");
      options.headers.Authorization = `Bearer ${newAccessToken}`;

      // Retry the fetch call with the new token
      response = await fetch(url, options);
    } else {
      // Handle failure to refresh token, e.g., redirect to login
      localStorage.removeItem("access");
      localStorage.removeItem("refresh");
      window.location.reload();
      console.error("Failed to refresh token.");
      // Redirect to login or perform other error handling
    }
  }

  return response;
}

// get paginated agency transactions
export const getTransactionLogs = async (id, pageNumber, searchTerm, dateRange, principalId) => {
  try {
    let url = `${ROOT_URL}/agency/user/${id}/transactions/?page=${pageNumber}`;

    // Add search parameter if provided
    if (searchTerm) {
      url += `&search=${encodeURIComponent(searchTerm)}`;
    }

    // Add date filter if both from and to dates are provided
    if (dateRange?.fromDate && dateRange?.toDate) {
      const fromDate = dateRange.fromDate.format("YYYY-MM-DD");
      const toDate = dateRange.toDate.format("YYYY-MM-DD");
      url += `&filter_date=${fromDate}_${toDate}`;
    }

    // Add principal filter if provided
    if (principalId) {
      url += `&principal=${principalId}`;
    }

    const response = await fetchWithTokenRefresh(url, {
      method: "GET",
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error);
    } else {
      return await response.json();
    }
  } catch (Exception) {
    console.error(Exception);
  }
};

export const getMerchantDetails = async id => {
  try {
    let url = `${ROOT_URL}/agency/user/${id}/`;

    const response = await fetchWithTokenRefresh(url, {
      method: "GET",
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error);
    } else {
      return await response.json();
    }
  } catch (Exception) {
    console.error(Exception);
  }
};

export const getTransactionDetails = async (agency_user_id, transaction_id) => {
  try {
    let url = `${ROOT_URL}/agency/user/${agency_user_id}/transactions/${transaction_id}/`;

    const response = await fetchWithTokenRefresh(url, {
      method: "GET",
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error);
    } else {
      return await response.json();
    }
  } catch (Exception) {
    console.error(Exception);
  }
};

export const getPaymentLogs = async (id, pageNumber) => {
  try {
    let url = `${ROOT_URL}/agency/user/${id}/payments/?page=${pageNumber}`;

    const response = await fetchWithTokenRefresh(url, {
      method: "GET",
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error);
    } else {
      return await response.json();
    }
  } catch (Exception) {
    console.error(Exception);
  }
};

export const downloadPaymentLogs = async id => {
  try {
    let url = `${ROOT_URL}/agency/user/${id}/payments/export`;

    const response = await fetchWithTokenRefresh(url, {
      method: "GET",
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error);
    } else {
      // Get the CSV blob
      let blob = await response.blob();

      // Read blob as text, add BOM, and create a new blob
      const text = await blob.text();
      const BOM = "\uFEFF";
      const utf8Blob = new Blob([BOM + text], { type: "text/csv;charset=utf-8;" });

      // Create a link and trigger download
      const urlObj = window.URL.createObjectURL(utf8Blob);
      const a = document.createElement("a");
      a.href = urlObj;
      a.download = "merchant_payment_logs.csv";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(urlObj);
      return true;
    }
  } catch (Exception) {
    console.error(Exception);
    return false;
  }
};
